import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('@aodocs/login-page').then((m) => m.LoginPageComponent),
    title: 'AODocs - login',
  },
  {
    path: 'preview',
    children: [
      {
        path: '',
        loadChildren: () => import('@aodocs/file-preview').then((m) => m.routes),
      },
    ],
  },
  { path: '', redirectTo: 'preview', pathMatch: 'full' },
  { path: '**', redirectTo: 'preview', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
